export const UniTemplate = function (template) {
  return template;
};
